import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "世界观解析", to: "/worldview" },
  { label: "角色图鉴", to: "/characters" },
  { label: "设定百科", to: "/settings" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const isActive = (to: string) =>
    to === "/" ? pathname === "/" : pathname.startsWith(to);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/80 shadow-[0_1px_0_0_oklch(var(--background-200))]"
          : "bg-background-50/40 backdrop-blur-sm"
      }`}
    >
      <nav className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 md:px-6 py-3.5">
        <a href="/" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-store-2-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            洞洞杂货铺
          </span>
          <span className="hidden sm:inline-flex rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-900 whitespace-nowrap">
            世界观解析站
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.to}
              href={link.to}
              className={`px-3 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                isActive(link.to)
                  ? "bg-primary-100 text-primary-800"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-200/60"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:block">
          <a
            href="/contact"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            联系我们
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          className="md:hidden flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-900"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.to}
                href={link.to}
                className={`rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
                  isActive(link.to)
                    ? "bg-primary-100 text-primary-800"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="/contact"
              className="mt-1 rounded-lg bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
            >
              联系我们
            </a>
          </div>
        </div>
      )}
    </header>
  );
}